import { gantt } from "@planzone/dto";

const initialState = gantt;

export { initialState };
